/**
 * fr-CA catalogue. PROVISIONAL — best-effort translation of en-GB,
 * following Québec French conventions (e.g. "courriel" for email,
 * "fin de semaine" rather than "week-end", title-case capitalisation).
 * Review by a Québec-French speaker before any Canadian francophone
 * tenant goes live.
 */

import type { TranslationMap } from '../i18n';

export const FR_CA: TranslationMap = {
  common: {
    save: 'Enregistrer les modifications',
    saving: 'Enregistrement…',
    saved: 'Modifications enregistrées.',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    loading: 'Chargement…',
    error_generic: "Une erreur s'est produite. Veuillez réessayer.",
    sign_in: 'Se connecter',
    sign_out: 'Se déconnecter',
    back: 'Retour',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    close: 'Fermer',
    open: 'Ouvrir',
    optional: 'Facultatif',
    required: 'Obligatoire',
  },

  nav: {
    home: 'Accueil',
    bookings: 'Réservations',
    pets: 'Animaux',
    profile: 'Profil',
    payments: 'Paiements',
    credits: 'Crédits',
    packs: 'Forfaits',
    notifications: 'Notifications',
    privacy: 'Confidentialité',
    book_now: 'Réserver',
    your_account: 'Votre compte',
  },

  account_home: {
    greeting: 'Bonjour {{ name }}',
    greeting_anonymous: 'Bienvenue',
    upcoming_bookings: 'Réservations à venir',
    no_upcoming: 'Aucune réservation à venir — réservez un séjour ou une journée de garderie.',
    your_pets: 'Vos animaux',
    no_pets: "Nous n'avons aucun animal enregistré pour vous.",
    quick_actions: 'Actions rapides',
  },

  bookings: {
    page_title: 'Vos réservations',
    upcoming: 'À venir',
    past: 'Passées',
    cancelled: 'Annulées',
    starts: 'Début',
    ends: 'Fin',
    pet: 'Animal',
    service: 'Service',
    total: 'Total',
    balance_due: 'Solde dû',
    status: 'Statut',
    view_details: 'Voir les détails',
    cancel_booking: 'Annuler la réservation',
    request_refund: 'Demander un remboursement',
    pay_balance: 'Payer le solde',
    photos: 'Photos',
    no_photos:
      "Aucune photo pour l'instant — l'équipe publiera des nouvelles ici pendant le séjour.",
    booking_id: 'Numéro de réservation',
  },

  pets: {
    page_title: 'Vos animaux',
    add_pet: 'Ajouter un animal',
    no_pets: "Vous n'avez aucun animal enregistré.",
    breed: 'Race',
    species: 'Espèce',
    weight: 'Poids',
    date_of_birth: 'Date de naissance',
    microchip: 'Micropuce',
    vaccinations: 'Vaccins',
    notes: 'Notes',
    upload_photo: 'Téléverser une photo',
    vet_sharing: 'Partage avec le vétérinaire',
  },

  profile: {
    page_title: 'Profil',
    section_eyebrow: 'Votre compte',
    name_label: 'Nom',
    name_placeholder: 'Votre nom',
    phone_label: 'Téléphone',
    email_label: 'Courriel',
    email_help: 'Contactez-nous pour changer votre courriel.',
    account_label: 'Compte :',
    language_label: 'Langue',
    language_help: 'Choisissez la langue de votre compte et de vos notifications.',
    save_failed: "Impossible d'enregistrer les modifications. Veuillez réessayer.",
    load_failed: 'Impossible de charger le profil. Veuillez réessayer.',
  },

  payments: {
    page_title: 'Paiements',
    history: 'Historique des paiements',
    no_payments: 'Aucun paiement pour le moment.',
    amount: 'Montant',
    paid_on: 'Payé le',
    method: 'Méthode',
    reference: 'Référence',
    receipt: 'Reçu',
    add_payment_method: 'Ajouter un mode de paiement',
  },

  sign_in: {
    page_title: 'Connexion à {{ accountName }}',
    page_title_default: 'Connexion',
    email_label: 'Adresse courriel',
    send_link: 'Envoyer le lien de connexion',
    sending: 'Envoi en cours…',
    link_sent_title: 'Vérifiez votre boîte de réception',
    link_sent_body:
      'Nous avons envoyé un lien de connexion à {{ email }}. Il expirera dans 15 minutes.',
    consume_loading: 'Connexion en cours…',
    consume_failed: "Nous n'avons pas pu vous connecter. Le lien est peut-être expiré.",
    back_to_sign_in: 'Retour à la connexion',
  },
};
